// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import getTextParts from '../../../../../../../common/utils/lib/getTextParts';

const NotificationMessage = (props) => {
    const { message, mentionRanges, showEllipsis = false } = props;

    const textParts = getTextParts({ text: message, ranges: mentionRanges });

    return (
        <div className="NotificationMessage">
            &ldquo;
            {textParts.map((textPart, index) => {
                const { text, isMatch } = textPart;

                return (
                    <span key={index} className={isMatch ? 'MentionEntity' : null}>
                        {text}
                    </span>
                );
            })}
            {showEllipsis ? '...' : null}
            &rdquo;
        </div>
    );
};

NotificationMessage.propTypes = {
    message: PropTypes.string,
    mentionRanges: PropTypes.array,
    showEllipsis: PropTypes.bool,
};

export default NotificationMessage;
